import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  * {\n    box-sizing: border-box;\n  }\n\n  html, body {\n    margin: 0;\n    font-family: base;\n    color: text;\n    line-height: 1.4;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  a, a:hover {\n    color: primary;\n    text-decoration: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from '@xstyled/styled-components';
import { normalize } from 'polished';
export var GlobalStyle = createGlobalStyle(_templateObject(), normalize());